<template>
  <ul v-show="noteList.length" class="note-box" ref="nodeList">
    <li
      v-for="item in noteList"
      :key="item.id"
      @click="goLocation(item)"
      :class="activeNote == item.id ? 'active' : ''"
    >
      <div class="top-box">
        <div class="top-title">{{ item.activeChapterName }}</div>
        <div class="top-button">
          <a class="add-mind-btn" @click.stop="mindMapAdd(item)">脑图</a>
        </div>
      </div>
      <p class="quote-txt quote-txt-2"><span class="ellipsis-2"><span class="quote-before">引自：</span>{{ item.content }}</span></p>
      <p class="noteTxt">{{ item.note }}</p>
      <div class="bot-box">
        <span class="update-time">更新时间：{{ item.updateTime }}</span>
        <div class="operate-box">
          <!-- <el-button @click.stop="mindMapAdd(item)" size="mini">
            {{ item.isMindMap ? '移除脑图' : '引入脑图' }}
          </el-button> -->
          <a class="edit-btn" @click.stop="editNote(item)">
            <span><i class="icon el-icon-edit"></i></span>
          </a>
          <a class="delete-btn" @click.stop="delRecordLi(item)">
            <span><i class="icon el-icon-delete"></i></span>
          </a>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "noteList",
  props: {
    noteList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    activeNote: {
      type: String,
      default: ''
    },
  },
  data() {
    return {}
  },
  watch: {
    activeNote() {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = this.$refs.nodeList.getElementsByClassName('active')[0];

          if (element) {
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: "start", // 垂直居中对齐
            });
          }
        }, 300)
      })
    }
  },
  methods: {
    // 切换章节以及表格的tab
    chapterChange(item) {
      return new Promise((resolve,reject) => {
        this.$emit('chapterChange', item.activeChapter, true);
        
        if((item.startNodeId + '').indexOf('table') > -1) {
          this.$nextTick(() => {
            setTimeout(()=> {
              let idBefore = item.startNodeId.split('table')[0];
              let tableTabKey = idBefore.substring(0, idBefore.length-1);
              let lastIndex = tableTabKey.lastIndexOf('.');
              let tableKey = tableTabKey.substring(0, lastIndex)
              this.$emit('tableTabChange', tableKey, tableTabKey);
              resolve();
            }, 20);
          });
        }else{
          resolve();
        }
      })
    },
    // 点击高亮列表，跳转到对应高亮处
    async goLocation(item) {
      let data_mark = item.id;
      this.activeMark = data_mark;
      await this.chapterChange(item)
      this.toElement(data_mark)
    },
    toElement(id) {
      const element = document.getElementById(id);
      if(!element) {
        setTimeout(() => {
          this.toElement(id)
        }, 500)
        return false
      }
      this.$nextTick(() => {
        setTimeout(()=> {
          // 导航滚动定位
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: "center", // 垂直居中对齐
            });
          }
        }, 100);
      })
    },
    mindMapAdd(item) {
      this.$emit('mindMapAdd', item)
    },
    delRecordLi(item) {
      this.$emit('delRecordLi', item.id)
    },
    editNote(item) {
      this.$emit('editNote', item.id)
    },
  }
}
</script>

<style lang="scss" scoped>
.note-box{
  li {
    padding: 20rem 39rem 22rem;
    border-bottom: 1rem solid #f1f1f1;
    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16rem;

      .top-title{
        font-size: 24rem;
        color: #999;
      }

      .top-button{
        .add-mind-btn{
          display: block;
          height: 50rem;
          line-height: 50rem;
          font-size: 26rem;
          color: #FFFFFF;
          text-align: center;
          border-radius: 6rem;
          background: #18C49E;
          cursor: pointer;
          user-select: none;
          overflow: hidden;
          padding: 0 15rem;
        }
      }
    }
    
    .quote-txt {
      margin-bottom: 16rem;
      padding: 14rem 16rem 16rem;
      height: auto;
      max-height: 90rem;
      font-size: 22rem;
      line-height: 30rem;
      color: #666;
      border-radius: 6rem;
      background: #f4f9f8;
      border: 1rem solid #e1edea;
      .quote-before{
        color: #999;
      }
    }
    .noteTxt {
      font-size: 28rem;
      line-height: 38rem;
      margin-bottom: 18rem;
      color: #313131;
      height: auto;
      max-height: 114rem;
      -webkit-line-clamp: 3;
    }
    .bot-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .update-time {
        font-size: 24rem;
        line-height: 50rem;
        color: #999999;
      }
      .operate-box {
        display: flex;
        a {
          margin-left: 10rem;
          width: 50rem;
          height: 50rem;
          font-size: 28rem;
          color: #2f4058;
          text-align: center;
          border-radius: 10rem;
          background: #fff;
          cursor: pointer;
          user-select: none;
          overflow: hidden;
          text-align: center;
          line-height: 50rem;
          i {
            font-size: 28rem;
            color: #2f4058;
            display: inline-block;
          }
        }
      }
    }
  }
  li:last-child {
    margin-bottom: 20rem;
    border-bottom: none;
  }
  li.active {
    background: #F7F7F7 url("~@/assets/images/common/location.png") left top no-repeat;
    background-size: 48rem 48rem;
  }
}
</style>